import { inject, Injectable } from '@angular/core';
import { ApiDataAccess, Dictionary, ReadonlyHttpApiListRepository } from '@softline/core';
import { StockPostingProduct } from '../models/product';
import { StockPostingQuery } from '../models/stock-posting-query';
import { SOFTLINE_API_MDE_STOCK_POSTING_PRODUCT_DETAIL } from '../einseitige-lagerbuchung.api';

@Injectable()
export class ProductRepository extends ReadonlyHttpApiListRepository<
  StockPostingProduct,
  StockPostingQuery
> {
  constructor() {
    super(inject(ApiDataAccess), SOFTLINE_API_MDE_STOCK_POSTING_PRODUCT_DETAIL);
  }

  override getLoadPathParams(params: StockPostingQuery): Dictionary<unknown> {
    return { id: params.id };
  }
}
